import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class DisbursementsService {
  constructor(private http: HttpClientService) {}

  public findOrValidateClabe(clabe: string): Observable<any> {
    const options = {
      clabe,
    };
    return this.http
      .get("/api/bank_accounts/find_or_validate_clabe", { params: options })
      .pipe(tap((_) => console.log("DisbursementsService.findOrValidateClabe: Ok.")));
  }

  public getAll(filters): Observable<any[]> {
    const options = {
      params: filters,
    };
    return this.http
      .get("/api/disbursements/all", options)
      .pipe(tap((_) => console.log("DisbursementsService.getAll: Ok.")));
  }

  public index(application_id: number): Observable<any> {
    return this.http
      .get(`/api/applications/${  application_id  }/disbursements`)
      .pipe(tap((_) => console.log("DisbursementsService.index: Ok.")));
  }

  public getStatusCount(): Observable<any> {
    return this.http
      .get("/api/disbursements/status_count")
      .pipe(tap((_) => console.log("DisbursementsService.getStatusCount: Ok.")));
  }

  public create(application_id: number, disbursement): Observable<any> {
    const options = {
      disbursement,
    };
    return this.http
      .post(`/api/applications/${  application_id  }/disbursements`, options)
      .pipe(tap((_) => console.log("DisbursementsService.create: Ok.")));
  }

  public update(disbursement): Observable<any> {
    const options = {
      disbursement,
    };
    return this.http
      .put(`/api/disbursements/${  disbursement.id}`, options)
      .pipe(tap((_) => console.log("DisbursementsService.update: Ok.")));
  }

  public updateOnBulk(disbursements: any[]): Observable<any> {
    console.log(disbursements);
    return this.http
      .put("/api/disbursements/bulk_update", { disbursements })
      .pipe(tap(() => console.log("Bulk update successful")));
  }

  public getAgencyInformation(id: number): Observable<any> {
    return this.http
      .get(`/api/disbursements/${  id  }/agency_information`)
      .pipe(tap((_) => console.log("DisbursementsService.getAgencyInformation: Ok.")));
  }

  public postEmailAgency(
    id: number,
    emails: string[],
    comments: string,
    financed_accessories = false
  ): Observable<any> {
    const options = { emails, comments, financed_accessories };
    return this.http
      .post(`/api/disbursements/${  id  }/email_agency`, options)
      .pipe(tap((_) => console.log("DisbursementsService.postEmailAgency: Ok.")));
  }

  public postCoverageProofsNotification(id: number, comments?: string): Observable<any> {
    const options = { comments };
    return this.http
      .post(`/api/disbursements/${  id  }/email_coverage_proofs`, options)
      .pipe(tap((_) => console.log("DisbursementsService.postCoverageProofsNotification: Ok.")));
  }

  public cancel(disbursementId: number, payload: { comment: string; file_id: number }): Observable<any> {
    return this.http
      .post(`/api/disbursements/${disbursementId}/cancellation`, payload)
      .pipe(tap((_) => console.log("DisbursementsService.cancel: Ok.")));
  }
}
